.removeTooltip {
  transition: none;

  > * {
    max-width: 14rem;
  }
}

.removeButton:hover {
  color: var(--hcr-danger-color);
}
